import { IoSearch } from 'react-icons/io5';

const SupportListItems = () => {
  return (
    <div className="bg-[#1E1E1E] h-screen w-full overflow-y-auto overflow-hidden flex flex-col">
      <div
        className="h-[40%] flex flex-col justify-center items-center gap-5"
        style={{
          background: 'linear-gradient(135deg, #000000 0%, #02287B 50%, #003E9D 100%)',
          backgroundBlendMode: 'overlay'
        }}
      >
        <label className="font-medium text-white text-xl">How can we help you?</label>
        <div className="relative">
          <IoSearch
            className="absolute top-1/2 right-5 transform -translate-y-1/2 w-5 h-5"
            color={'#000000'}
          />
          <input
            type="text"
            className="rounded-lg bg-white text-[#000000] text-sm px-5 py-3 placeholder:text-[#000000] w-[400px]"
            placeholder="What are you looking for?"
          />
        </div>
      </div>
    </div>
  );
};

export default SupportListItems;
